/* eslint-disable no-magic-numbers */
import dayjs from "dayjs";
import { Appointment, TimeSlotLength } from "./Appointment";
import { getAppointmentStatus } from "./get-appointment-status";

export const createHead = (isAfter: boolean) => {
    const head = {
        cells: [
            {
                key: "user.username",
                content: "Benutzerin Pseudonym",
                width: 10,
            },
            {
                key: "userInsuranceName",
                content: "Versicherung",
                width: 12,
            },
            {
                key: "datum",
                content: "Datum",
                width: 12,
            },
            {
                key: "prepare",
                content: "Vorbereitungsbeginn",
                width: 17,
            },
            {
                key: "start",
                content: "Terminstart",
                width: 12,
            },
            {
                key: "end",
                content: "Endzeit",
            },
            {
                key: "status",
                content: "Status",
            },
        ],
    };
    if (!isAfter) {
        head.cells.push({
            key: "canceledAt",
            content: "Stornozeitpunkt",
        });
    }
    if (isAfter) {
        head.cells.push(
            {
                key: "reassign",
                content: "Zu einem anderen Trainer zuweisen",
                width: 10
            },
            {
                key: "actions",
                content: "Abbrechen",
            }
        );
    }
    return head;
};

export const createUserHead = (isAfter: boolean) => {
    const head = {
        cells: [
            {
                key: "coach.username",
                content: "Coach Pseudonym",
            },
            {
                key: "datum",
                content: "Datum",
            },
            {
                key: "prepare",
                content: "Vorbereitungsbeginn",
            },
            {
                key: "start",
                content: "Terminstart",
            },
            {
                key: "end",
                content: "Endzeit",
            },
            {
                key: "status",
                content: "Status",
            },
        ],
    };
    if (!isAfter) {
        head.cells.push({
            key: "canceledAt",
            content: "Stornozeitpunkt",
        });
    }

    return head;
};

export const getUserAppointmentRows = (
    appointments: Appointment[],
    isAfter: boolean
) =>
    appointments.map((appointment, index) => {
        const rows = {
            key: `row-${index}-${appointment.id}`,
            cells: [
                {
                    key: "coach.username",
                    content: (
                        <div>
                            {appointment.coach.username
                                ? appointment.coach.username
                                : "<Kein Pseudonym>"}
                        </div>
                    ),
                },
                {
                    key: "datum",
                    content: dayjs
                        .unix(
                            parseInt(
                                appointment.startDateTime as unknown as string,
                                10
                            )
                        )
                        .format("DD.MM.YYYY"),
                },
                {
                    key: "prepare",
                    content: dayjs
                        .unix(
                            parseInt(
                                appointment.startDateTime as unknown as string,
                                10
                            )
                        )
                        .format("hh:mm A"),
                },
                {
                    key: "start",
                    content: dayjs
                        .unix(
                            parseInt(
                                appointment.startDateTime as unknown as string,
                                10
                            )
                        )
                        .add(15, "minute")
                        .format("hh:mm A"),
                },
                {
                    key: "end",
                    content: dayjs
                        .unix(
                            parseInt(
                                appointment.startDateTime as unknown as string,
                                10
                            )
                        )
                        .add(TimeSlotLength, "minute")
                        .format("hh:mm A"),
                },
                {
                    key: "status",
                    content: getAppointmentStatus(appointment),
                },
            ],
        };

        if (!isAfter) {
            rows.cells.push({
                key: "canceledAt",
                content: appointment.canceledAt
                    ? dayjs(appointment.canceledAt).format("YYYY-MM-DD HH:mm")
                    : "Nicht bekannt",
            });
        }

        return rows;
    });
